define('Facets.MultiAddToCart.Cell.View', [
    'facets_multi_add_to_cart_cell.tpl',
    'MultiAddToCart.ItemRow.View',
    'Backbone',
    'underscore'
], function (
    facets_multi_add_to_cart_cell_tpl,
    ItemRowView,
    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: facets_multi_add_to_cart_cell_tpl,

        contextDataRequest: ['item'],

        initialize: function initialize(options) {
            var self = this;
            this.container = options.container;
            this.getRegistrationType = options.getRegistrationType,
            this.addToCartViews = options.addToCartViews;
            var userProfile = this.options.container.getComponent('UserProfile');
            this.plp = this.options.container.getComponent('PLP');
            var categoryinfo = this.plp.getCategoryInfo();
            this.categoryName = categoryinfo && categoryinfo.name;

            userProfile.getUserProfile().done(function (profile) {
                self.isloggedin = profile.isloggedin;
                self.render();
            });
        },

         childViews: {
            'MultipleAddTo.MultipleRow': function () {
                var self = this;
                var item = this.contextData.item && this.contextData.item();
        

                var viewContainer = new Backbone.View(); // simple container view
                // render N row views into container.$el after container renders
                viewContainer.render = function () {
                    this.$el.empty();
                    (item.matrixchilditems_detail || []).forEach(function (childModel) {
                        var itemURL = item.urlcomponent + '?';
                        var childItemCategories = childModel.custitem_ma2c_category.split(',').map(function(s) { return s.trim(); });
                        if(_(childItemCategories).contains(self.categoryName)) {
                            _.each(item.itemoptions_detail && item.itemoptions_detail.fields, function (field){
                                var optionValue = _.findWhere(field && field.values, {label: childModel[field.sourcefrom]});
                                if(optionValue) {
                                    itemURL +=  field.internalid + '=' + optionValue.internalid + '&';
                                }
                            });
                            
                            if(itemURL.endsWith('&')) {
                                itemURL = itemURL.slice(0, -1);
                            }
                            childModel.keyMapping_thumbnail = item.keyMapping_thumbnail;
                            childModel.urlcomponent = itemURL;
                            var row = new ItemRowView({ 
                                item: childModel,
                                container: self.container,
                                getRegistrationType: self.getRegistrationType,
                                addToCartViews: self.addToCartViews,
                                isloggedin: self.isloggedin,
                                parentView: self });
                            viewContainer.$el.append(row.render().el);
                        }
                     
                    });
                };

                return viewContainer;
            },

            'MultipleAddTo.SingleRow': function () {
                var self = this;

                var item = this.contextData.item && this.contextData.item();
                return new ItemRowView({ 
                    item: item,
                    container: self.container,
                    getRegistrationType: self.getRegistrationType,
                    addToCartViews: self.addToCartViews,
                    parentView: self,
                    isloggedin: self.isloggedin
                });
            }
        },

        getContext: function () {
            var item = this.contextData.item && this.contextData.item();
            return {
                isMatrixItem: item && item.matrixchilditems_detail
            };
        }
    });
});
